// @flow
import React from 'react';
import {connect} from 'react-redux';
import {EdapProvider} from '@homeaway/react-event-tracking';
import Experiment from '@homeaway/react-experiment';

import FlexibleDates from './FlexibleDates';
import {media} from '../../utils/breakpoints';
import routerActions from '../../actions/router';
import type {State as ReduxState} from '../../reducers/index';

import {VRBO_WEB_FLEX_DATE} from '../../abacus/experiments';

type StateProps = {
    startDate?: string,
    endDate?: string,
    locale: string,
    title: string,
    isDesktop: boolean
};

type OwnProps = {
    loading: boolean
};

type DispatchProps = {
    search: typeof routerActions.search
};

type Props = StateProps & DispatchProps & OwnProps;

export function FlexibleDatesContainer({search, ...props}: Props) {
    function onDateChange(arrival: string, departure: string) {
        search({arrival, departure});
    }

    const defaultFields = {
        eventcategory: 'flexible dates'
    };

    return (
        <Experiment name={VRBO_WEB_FLEX_DATE} variant={Experiment.ON}>
            <EdapProvider fields={defaultFields}>
                <FlexibleDates {...props} onDateChange={onDateChange} />
            </EdapProvider>
        </Experiment>
    );
}

const mapStateToProps = (
    {
        abacus,
        searchParams: {
            params: {arrival, departure}
        },
        system: {locale},
        viewport: {breakpoint}
    }: ReduxState,
    {loading}: OwnProps
): StateProps & OwnProps => {
    const variant = (abacus[VRBO_WEB_FLEX_DATE] || {}).value;
    const title = variant ? `flexibleDatesTitle${variant}` : '';

    return {
        startDate: arrival,
        endDate: departure,
        locale,
        isDesktop: media(breakpoint, {
            minWidth: 'SM_MIN'
        }),
        loading,
        title
    };
};

const mapDispatchToProps = {
    search: routerActions.search
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FlexibleDatesContainer);
